export const favoriteFilterKeys = {
	parentAffiliateIds: 'favAffSARV2ParentAffiliateIds',
	referredAffiliateIds: 'favAffSARV2ReferredAffiliateIds',
	commissionLevels: 'favAffSARV2CommissionLevels',
	deals: 'favAffSARV2Deals',
	players: 'favAffSARV2PlayerIds',
	brands: 'favAffSARV2Brands',
	currencies: 'favAffSARV2Currencies',
	productIds: 'favAffSARV2ProductIds',
	platformIds: 'favAffSARV2PlatformIds',
	geo: 'favAffSARV2Geo',
}

export const reportStorageProps = {
  type: 'aff-sub-affiliate-report-v2',
  target: 'filters',
  tableSettingsTarget: 'table-settings',
  exceptions: ['group_by', 'period', 'sent_from', 'sent_to'],
  exceptionsIds: ['productIds', 'platformIds', 'brands', 'currencies'],
  exceptionsStr: ['players'],
}
